module.exports = __webpack_public_path__ + "static/media/LogicWheel2_2_row_2.a8ddc6d5.png";